import { Fragment } from "react";
import { ConstructorContainer } from "../../ui/constructorContainer/ConstructorContainer.js";
import { instanceOfGrid } from "../grid/instanceOfGrid.js";
function getContainerWithProps(item, isSubConstructor) {
  var _a;
  if (isSubConstructor) {
    return {
      Container: Fragment,
      containerProps: {}
    };
  }
  const ContainerComponent = item.withContainer ? item.Container ?? ConstructorContainer : Fragment;
  const containerProps = item.containerProps || {};
  const resolveContainerProps = item.withContainer ? {
    style: {
      [`--pa-${item.id}-constructor-container-background-color-inner`]: `var(--pa-${item.id}-constructor-container-background-color, ${((_a = containerProps.style) == null ? void 0 : _a.backgroundColor) ?? "transparent"})`,
      ...containerProps.style,
      backgroundColor: `var(--pa-${item.id}-constructor-container-background-color-inner)`
    }
  } : {};
  return {
    Container: ContainerComponent,
    containerProps: resolveContainerProps
  };
}
function prepareConstructorGridItems(items, isSubConstructor) {
  return items.map((item) => {
    const isGrid = instanceOfGrid(item);
    if (!isGrid) {
      return {
        ...item,
        ...getContainerWithProps(item, isSubConstructor)
      };
    }
    return {
      ...item,
      ...getContainerWithProps(item, isSubConstructor),
      items: prepareConstructorGridItems(item.items, isSubConstructor)
    };
  });
}
function prepareConstructorLayout(layout, isSubConstructor) {
  return {
    ...layout,
    ...getContainerWithProps(layout, isSubConstructor),
    items: prepareConstructorGridItems(layout.items, isSubConstructor)
  };
}
export {
  prepareConstructorLayout
};
